import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getGiftCardItem } from '../../services/gift-cards';

function useGetGiftCardItem({
  enabled: passedEnabled = true,
}: { enabled?: boolean } = {}) {
  const { user } = useUser();

  const enabled = !!user?.business?.id && passedEnabled;

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ['gift-card-item', user?.business?.id],
    queryFn: async () =>
      getGiftCardItem({
        businessId: user!.business!.id!,
      }),
    enabled,
  });

  return {
    data,
    isLoading: enabled && isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}

export default useGetGiftCardItem;
